/** Best-effort detail string from axios-style API errors. */
export function getApiErrorDetail(err: unknown): string | null {
  if (typeof err === 'string' && err.trim()) return err
  if (err instanceof Error && err.message.trim()) {
    // Prefer response body when present; fall through below for axios errors.
    if (!('response' in err)) return err.message
  }
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: Record<string, unknown> } })
      .response?.data
    if (!data) {
      return err instanceof Error && err.message.trim() ? err.message : null
    }
    const detail = data.detail
    if (typeof detail === 'string' && detail.trim()) return detail
    const message = data.message
    if (typeof message === 'string' && message.trim()) return message

    const error = data.error
    if (error && typeof error === 'object') {
      const details = (error as { details?: unknown }).details
      if (Array.isArray(details) && details.length > 0) {
        const first = details[0]
        if (typeof first === 'string' && first.trim()) return first
        if (first && typeof first === 'object' && 'message' in first) {
          const nested = (first as { message?: unknown }).message
          if (typeof nested === 'string' && nested.trim()) return nested
        }
      }
    }
  }
  if (err instanceof Error && err.message.trim()) return err.message
  return null
}
